import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/leads/touches/$touchId")({
    beforeLoad: ({ params, search }) => {
        throw redirect({ to: "/sales/leads/touches/$touchId", params, search, replace: true });
    },
});
